import {} from '@fullstory/snippet';
import { createContext } from 'react';
const FullstoryContext = createContext(null);
export default FullstoryContext;
//# sourceMappingURL=fullstory.js.map